import React from 'react'
import PageShell from '../components/ui/PageShell'
import Card from '../components/ui/Card'
import SectionTitle from '../components/ui/SectionTitle'
import { AccordionSection } from '../components/ui/Accordion'

const faqItems = [
  {
    q: 'Was ist das AI Mastering Studio?',
    a: 'Eine Anwendung zum automatischen Mastering deiner Tracks: Upload, Analyse, KI-gestütztes Mastering, optional Cover- und Canvas-Generierung. Von Musiker für Musiker.',
  },
  {
    q: 'Welche Formate werden unterstützt?',
    a: 'Upload: WAV (empfohlen), FLAC. Nach dem Mastering kannst du WAV und MP3 herunterladen sowie Cover (PNG) und optional ein Spotify-Canvas (Bild oder Video) erzeugen.',
  },
  {
    q: 'Was ist ein Spotify-Canvas?',
    a: 'Ein kurzes Looping-Bild oder -Video (z. B. 9:16), das auf Spotify beim Abspielen hinter dem Player angezeigt wird. Du kannst es hier passend zu Titel und Song generieren – als Bild oder Video, optional mit eigenem Design-Prompt.',
  },
  {
    q: 'Wie funktioniert die Cover-Generierung?',
    a: 'Über „Cover generieren“ wählst du, ob Titel und Künstler auf dem Cover erscheinen sollen oder nur das Bild. DALL-E erzeugt das komplette Cover inkl. Text. Optional kannst du einen Design-Prompt angeben (z. B. Stil, Farben).',
  },
  {
    q: 'Wo finde ich die Anleitung?',
    a: 'Im Footer findest du den Link „Anleitung“ – dort ist die Nutzung Schritt für Schritt beschrieben.',
  },
  {
    q: 'Wer steckt hinter der Anwendung?',
    a: 'Anbieter ist Marc Fischer Digital Solution NRW (Lärchenweg 9, 50389 Wesseling). Impressum, Datenschutz, AGB und Nutzungsbedingungen findest du im Footer. Kontakt: kontakt@anwendungen.online.',
  },
]

export default function FAQ() {
  return (
    <PageShell>
      <SectionTitle title="FAQ" />
      <Card className="mt-4">
        <div className="divide-y divide-white/10">
          {faqItems.map((item, i) => (
            <AccordionSection key={i} title={item.q} defaultOpen={i === 0}>
              <p className="text-sm text-white/80 leading-relaxed">{item.a}</p>
            </AccordionSection>
          ))}
        </div>
      </Card>
    </PageShell>
  )
}
